class ImageCallout extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-el="image-callout.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="image-callout.slide"]')
    this.scrollerEl = this.querySelector('[data-el="image-callout.scroller"]')

    if (this.slideEls.length < 2) return

    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    return new window.KeenSlider551(this.slidesEl, {
      slides: '.car-Carousel_Slide',
      slidesPerView: 1.33333,
      spacing: 15,
      rubberband: false,
      breakpoints: {
        '(min-width: 600px)': {
          slidesPerView: 2,
          spacing: 15
        },
        '(min-width: 768px)': {
          slidesPerView: 2.4,
          spacing: 30
        },
        '(min-width: 901px)': {
          slidesPerView: 3,
          spacing: 30
        }
      },
      created: () => {
        this.slidesEl.classList.remove('car-Carousel_Slides-hidden')
      },
      move: instance => {
        if (this.scrollerEl) {
          let progressTrack = instance.details().progressTrack
          progressTrack = progressTrack >= 1 ? 0 : progressTrack
          const movementPercentage = progressTrack * 100
          this.scrollerEl.style.setProperty(
            '--movement',
            `${movementPercentage}%`
          )
        }
      }
    })
  }
}

customElements.define('image-callout', ImageCallout)
